'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _capeStyle = require('cape-style');

var _capeStyle2 = _interopRequireDefault(_capeStyle);

var _dropZoneUtils = require('./dropZoneUtils');

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var baseStyle = (0, _capeStyle2.default)('bgGray pt5 pb5 pl2 pr2 mb2');
var styles = {
  base: baseStyle,
  onHover: _extends({}, baseStyle, (0, _capeStyle2.default)('bgWashedBlue ba bw0p125')) // Should only provide drop functionality. Nothing more. Use Uploading component to show progress.

};

function DropZone(_ref) {
  var hasFocus = _ref.hasFocus,
      message = _ref.message,
      onDragEnter = _ref.onDragEnter,
      onDragLeave = _ref.onDragLeave,
      onDragOver = _ref.onDragOver,
      onSelect = _ref.onSelect,
      style = _ref.style;
  var inlineStyle = hasFocus ? styles.onHover : styles.base;
  return _react2.default.createElement('div', {
    style: _extends({}, inlineStyle, style),
    onDragEnter: onDragEnter,
    onDragLeave: onDragLeave,
    onDragOver: onDragOver,
    onDrop: onSelect,
    className: 'dropzone'
  }, _react2.default.createElement('p', null, message, ' ', _react2.default.createElement('br', null), _react2.default.createElement(_Icon2.default, {
    style: (0, _capeStyle2.default)('mt1'),
    symbol: 'picture-o',
    className: 'fa-3x'
  })), hasFocus && _react2.default.createElement('p', null, 'Drop it'));
}

DropZone.propTypes = {
  hasFocus: _propTypes2.default.bool,
  // id: PropTypes.string,
  onDragEnter: _propTypes2.default.func,
  onDragLeave: _propTypes2.default.func,
  onDragOver: _propTypes2.default.func,
  // onDrop: PropTypes.func,
  onSelect: _propTypes2.default.func,
  message: _propTypes2.default.string.isRequired,
  style: _propTypes2.default.object
};
DropZone.defaultProps = {
  message: 'Drop in a new file to upload.',
  multiple: false,
  onDragOver: _dropZoneUtils.handleHover,
  style: {}
};
exports.default = DropZone;
module.exports = exports['default'];